import { useTheme } from "../context/ThemeContext";

export const ThemeToggleButton: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative flex items-center justify-center w-10 h-10 text-gray-500 transition-colors bg-white border border-gray-200 rounded-lg dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none focus:ring-3 focus:ring-brand-500/10"
      aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
    >
      {/* Sun Icon - visible in dark mode */}
      <span
        className={`absolute transition-all duration-300 ${
          theme === "dark" ? "opacity-100 rotate-0" : "opacity-0 rotate-90"
        }`}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2.5V4.16667M10 15.8333V17.5M4.16667 10H2.5M6.54583 6.54583L5.36667 5.36667M13.4542 6.54583L14.6333 5.36667M6.54583 13.4542L5.36667 14.6333M13.4542 13.4542L14.6333 14.6333M17.5 10H15.8333M13.3333 10C13.3333 11.8409 11.841 13.3333 10 13.3333C8.15905 13.3333 6.66667 11.8409 6.66667 10C6.66667 8.15905 8.15905 6.66667 10 6.66667C11.841 6.66667 13.3333 8.15905 13.3333 10Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>

      {/* Moon Icon - visible in light mode */}
      <span
        className={`absolute transition-all duration-300 ${
          theme === "light" ? "opacity-100 rotate-0" : "opacity-0 -rotate-90"
        }`}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5 10.8333C17.0175 13.8502 14.7408 16.2629 11.7499 16.9254C8.75898 17.5879 5.68018 16.3746 3.98645 13.8332C2.29271 11.2917 2.20669 7.99805 3.76566 5.37337C5.32462 2.74868 8.30926 1.34816 11.3333 1.83333C9.77367 3.79667 9.39333 6.4445 10.3333 8.75C10.8333 10 12.0833 11.25 13.3333 11.75C14.5833 12.25 16.6667 12 17.5 10.8333Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  );
};

export default ThemeToggleButton;
